import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '700&nbsp;000+',
        showDataSubtitle: 'охват в&nbsp;таргетированной рекламе',
    },
    {
        showDataTitle: 'на&nbsp;33%',
        showDataSubtitle: 'перевыполнили план по&nbsp;сбору анкет',
    },
    {
        showDataTitle: '600&nbsp;000+',
        showDataSubtitle: 'охват в&nbsp;контекстной рекламе',
    },
    {
        showDataTitle: '270',
        showDataSubtitle: 'заявок за&nbsp;1&nbsp;день работы квиза',
    },
    {
        showDataTitle: '800&nbsp;000',
        showDataSubtitle: 'показов за&nbsp;неделю по&nbsp;подготовительным курсам',
    },
];

class Results extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="mid-results" smallPaddings={true}>
                    <CommonTitle>Результаты</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1.5}
                    >
                        <div className="mid-ciphers">
                            <div className="mid-ciphers__wrapper">
                                <div className="mid-results-ciphers__grid">
                                    {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                        <ScrollAnimation
                                            animateIn="fadeInUp"
                                            offset={0}
                                            delay={100}
                                            animateOnce={true}
                                            duration={1}
                                            className="mid-results-ciphers__item"
                                            key={index}
                                        >
                                            <div className="mid-results-ciphers__item-wrap">
                                                <div
                                                    className="mid-results-ciphers__name"
                                                    dangerouslySetInnerHTML={{
                                                        __html: showDataTitle,
                                                    }}
                                                ></div>
                                                <CommonSmallText className="mid-results-ciphers__desc">
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: showDataSubtitle,
                                                        }}
                                                    ></p>
                                                </CommonSmallText>
                                            </div>
                                        </ScrollAnimation>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
